import { LogoImg, PageContainer } from "pages/Auth/Login/Login.style";
import React, { useEffect, useMemo, useState } from "react";
import { FieldValues, useForm } from "react-hook-form";
import LogoBlue from "assets/svg/Airgain_logo_color.svg";
import { CommonSelect } from "components/common/common-select/common-select.component";
import { PageSection } from "components/common/Wrapper";
import { AuthButton } from "components/common/Buttons";
import { CommonText } from "components/common/text/text.component";
import { getCurrentUser } from "pages/Auth/Cogcognito";
import { useNavigate } from "react-router";
import { Spinner } from "components/common/spinner/spinner.component";
import { Popup } from "components/common/popup/popup.component";
import { getUserGroups } from "api/AdminHelpers";
import { useAuth } from "hooks/useProvideAuth";
import { updateUserSetting } from "api/UserSettingHelpers";

export default function OrgSelectionPage() {
  const navigate = useNavigate();
  const [userGroups, setUserGroups] = useState<any>([]);
  const [selectedOrg, setSelectedOrg] = useState<string>("");
  const [userDetails, setUserDetails] = useState<any>([]);
  const [isOrgUpdating, setIsOrgUpdating] = useState<boolean>(false);
  const [isPageLoading, setIsPageLoading] = useState<boolean>(false);
  const [isConfirmationOpen, setIsConfirmationOpen] = useState<boolean>(false);

  const { signOut }: any = useAuth();

  const groupsList = useMemo(() => {
    if (!userGroups || !userGroups.length) {
      return [];
    }
    const newList = userGroups?.map((item: any) => {
      const newObj = {
        label: item.GroupName,
        value: item.GroupName,
      };

      return newObj;
    });
    return newList;
  }, [userGroups]);

  const {
    control,
    watch,
    formState: { errors },
  }: FieldValues = useForm({
    values: { organization: selectedOrg },
  });
  const selectedGroup = watch("organization");

  const onSubmit = async () => {
    const currentOrg = userDetails.find((obj: any) => obj.Name === "profile");

    if (selectedGroup === currentOrg.Value) {
      localStorage.setItem("selectedOrg", selectedGroup);
      return navigate("/devices");
    }

    setIsConfirmationOpen(true);
  };

  const onReLoginConfirmation = async () => {
    try {
      setIsConfirmationOpen(false);
      localStorage.setItem("hasSelectedOrg", "true");

      setIsOrgUpdating(true);
      const name = userDetails.find((obj: any) => obj.Name === "sub");
      const email = userDetails.find((obj: any) => obj.Name === "email");

      const newObj = {
        username: name.Value,
        email: email.Value,
        groupname: selectedGroup,
      };

      await updateUserSetting(newObj);
      localStorage.setItem("selectedOrg", selectedGroup);

      setIsOrgUpdating(false);

      await signOut();
    } catch (error: any) {
      console.warn("Error", error);
    }
  };

  const getUserDetails = async () => {
    try {
      const userData = await getCurrentUser();
      const profile = userData.find((obj: any) => obj.Name === "profile");

      setSelectedOrg(profile.Value);

      setUserDetails(userData);

      const name = userData.find((obj: any) => obj.Name === "sub");

      const response = await getUserGroups(name.Value);

      setUserGroups(response);
      setIsPageLoading(false);
    } catch (error: any) {
      console.warn("error", error);
    }
  };

  useEffect(() => {
    setIsPageLoading(true);

    getUserDetails();
  }, []);

  return (
    <div style={{ height: "100vh", backgroundColor: "var(--mega-color-gray100)" }}>
      <PageContainer>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          <PageSection
            style={{
              width: "400px",
              height: "450px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              borderRadius: "8px",
              justifyContent: "space-between",
            }}
          >
            <div>
              <LogoImg src={LogoBlue} alt="logo" />

              <div style={{ paddingBottom: "32px", width: "300px" }}>
                <CommonText>Please select the organization you would like to view below</CommonText>
              </div>
              <div style={{ display: "flex", flexDirection: "column", width: "300px" }}>
                <CommonSelect
                  name="organization"
                  label="Organization"
                  options={groupsList}
                  control={control}
                  rules={{ required: "Role is required" }}
                  error={errors.role}
                />
              </div>
            </div>
            <div style={{ width: "300px", paddingBottom: "16px" }}>
              <AuthButton onClick={onSubmit}>Submit</AuthButton>
            </div>
          </PageSection>
        </div>
      </PageContainer>

      <Popup title="Loading..." open={isPageLoading}>
        <Spinner />
      </Popup>

      <Popup title="Setting User's Organization..." open={isOrgUpdating}>
        <Spinner />
      </Popup>

      <Popup
        primaryBtn={{ text: "Continue", onClick: onReLoginConfirmation }}
        secondaryBtn={{ text: "Cancel", onClick: () => setIsConfirmationOpen(false) }}
        title="Confirmation"
        open={isConfirmationOpen}
      >
        <CommonText>
          Selecting a different organization will require you to re-login with your user name and password.
        </CommonText>
      </Popup>
    </div>
  );
}
